/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { paths } from 'client/shared/Paths';
import { Modal } from '@spotify-internal/anchor-ds';
import { useT } from 'client/i18n/hooks/useT';

export function UnpublishEpisodeErrorModal({
  onClose,
  action,
}: {
  onClose: () => void;
  action: 'delete' | 'unpublish';
}) {
  const t = useT();

  return (
    <Modal
      isShowing
      isShowingCloseButton
      aria-labelledby="unpublish-episode-error-modal-title"
      onClose={onClose}
    >
      <Modal.Title id="unpublish-episode-error-modal-title">
        {action === 'delete'
          ? t(
              'UnpublishEpisodeErrorModal.UnableToDeleteTitle',
              'Unable to delete episode',
              'Delete episode error modal title'
            )
          : t(
              'UnpublishEpisodeErrorModal.UnableToUnpublishTitle',
              'Unable to unpublish episode',
              'Unpublish episode error modal title'
            )}
      </Modal.Title>
      <Modal.Body>
        {t(
          'UnpublishEpisodeErrorModal.UnableToUnpublishMessage',
          "{action} this episode would leave your RSS feed empty and break your podcast on external platforms. If you'd like to delete your podcast, please {helpPageLink}. If you just want to remove this episode, create a new one first.",
          'Episode action error modal message',
          {
            action:
              action === 'delete'
                ? t(
                    'UnpublishEpisodeErrorModal.DeleteActionText',
                    'Deleting',
                    'Deleting action text'
                  )
                : t(
                    'UnpublishEpisodeErrorModal.UnpublishActionText',
                    'Unpublishing',
                    'Unpublishing action text'
                  ),
            helpPageLink: (
              <a
                href={paths.getHelpPage('home')}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t(
                  'UnpublishEpisodeErrorModal.HelpLinkText',
                  'get in touch with us',
                  'Help link text'
                )}
              </a>
            ),
          }
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonPrimary onClick={onClose}>
          {t('Button.GotIt', 'Got it', 'Dismiss button text')}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}
